import { render, staticRenderFns } from "./certificationActivities.vue?vue&type=template&id=30243308"
import script from "./certificationActivities.vue?vue&type=script&lang=js"
export * from "./certificationActivities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports